import { render, staticRenderFns } from "./InAppVideos.vue?vue&type=template&id=a2f36a06&scoped=true&"
import script from "./InAppVideos.vue?vue&type=script&lang=js&"
export * from "./InAppVideos.vue?vue&type=script&lang=js&"
import style0 from "./InAppVideos.vue?vue&type=style&index=0&id=a2f36a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f36a06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
